import React from 'react';

import { AlertDescription } from '../../../../_mui/_alerts_/NotificationAlert';
import { useUploadModal } from '../../UploadModalContext';
import SampleTable from '../SampleTable/SampleTable';

const AlertTable: React.FC = () => {
  const { profile } = useUploadModal();

  return (
    <>
      <AlertDescription sx={{ fontSize: '12px' }}>
        {profile.copy.preparingCsvAlert.requiredHeadersHelper}
      </AlertDescription>
      <SampleTable />
    </>
  );
};

export default AlertTable;
